import Vue from 'vue'
import VueCookies from 'vue-cookies' // 引入cookies 插件
Vue.use(VueCookies)
import CryptoJS from 'crypto-js'
Vue.use(CryptoJS)
function setCookies (username, password, exDays = 60) {
  // Encrypt，加密账号密码
  var cipherUsername = CryptoJS.AES.encrypt(
    username + '',
    'secretKey'
  ).toString()
  var cipherPsw = CryptoJS.AES.encrypt(password + '', 'secretKey').toString()
  let exDate = new Date() // 获取时间
  exDate.setTime(exDate.getTime() + 24 * 60 * 60 * 1000 * exDays) // 保存的天数

  window.document.cookie = `currentUsername =${cipherUsername};path=/;expires = ${exDate.toUTCString()}`
  window.document.cookie = `password =${cipherPsw};path=/;expires = ${exDate.toUTCString()}`
}

function getCookies () {
  let cipherUsername = $cookies.get(`currentUsername`)
  let cipherPsw = $cookies.get(`password`)
  // 将用户名解码
  let decryptUsername = CryptoJS.AES.decrypt(
    cipherUsername,
    `secretKey`
  ).toString(CryptoJS.enc.Utf8)
  // 将密码解码
  let decryptPwd = CryptoJS.AES.decrypt(cipherPsw, `secretKey`).toString(
    CryptoJS.enc.Utf8
  )
  //   console.log(decryptUsername, decryptPwd)
  return [decryptUsername, decryptPwd]
}

function clearCookies () {
  window.$cookies.remove(`currentUsername`)
  window.$cookies.remove(`password`)
}
export { setCookies, getCookies, clearCookies }
